module.exports = __webpack_public_path__ + "static/media/maximize.3480a945.svg";